import { defineStore } from 'pinia';
import { WINNERS_REQUEST_INTERWAL } from '~/utils/constants';
import { parsePreloadWinners, parseWinner } from '~/utils/ss/winners';
import { useStoreRoot } from '../abstract/root';
import { useStoreCurrencyMenu } from '../strapi/currencyMenu';
import { softswiss } from '../transport/softswiss';
import type { ISsWinners, TSsWinnersResponse, ISsWinnersSlider } from '~/types/softswiss/ssWinners';

export const useStoreWinnersList = defineStore('winnersList', {
  state: () => ({
    lastWinnerId: 0 as number,
    winnersList: [] as ISsWinners[],
    intervalId: NaN,
    requestPromise: null as Promise<any> | null,
  }),
  getters: {
    latestWinners(state): ISsWinnersSlider[] {
      let winnersList = state.winnersList;
      if (useStoreRoot().isEstonianLicense) {
        const isFiatCurrency = useStoreCurrencyMenu().isFiatCurrency;
        winnersList = state.winnersList.filter((item) => isFiatCurrency(item.round.currency));
      }
      return winnersList.map((winner) => parseWinner(winner));
    },
  },
  actions: {
    fetchData() {
      if (!this.requestPromise) {
        const path = usePlatform().isDesktop
          ? '/api/cf/stats/winners/latest/desktop'
          : '/api/cf/stats/winners/latest/mobile';

        this.requestPromise = softswiss()
          .get({ path, force: true })
          .finally(() => (this.requestPromise = null));
      }

      return this.requestPromise;
    },
    async load(): Promise<void> {
      const preloadWinners = (await this.fetchData()) as TSsWinnersResponse;

      if (preloadWinners && Array.isArray(preloadWinners)) {
        const newWinnersList = parsePreloadWinners(preloadWinners);

        if (this.winnersList.length + newWinnersList.length > 100) {
          this.winnersList.slice(newWinnersList.length);
        }

        this.winnersList = [...this.winnersList, ...newWinnersList];
      }
    },
    subscribeWinners(): void {
      if (this.intervalId) {
        this.unsubscribeWinners();
      }

      this.intervalId = window.setInterval(() => {
        this.load();
      }, WINNERS_REQUEST_INTERWAL);
    },
    unsubscribeWinners(): void {
      window.clearInterval(this.intervalId);
    },
  },
});
